import React, { useState } from 'react';
import { productsData } from '../data/mock';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { ShoppingCart } from 'lucide-react';

export const Products = () => {
  const [selectedCategory, setSelectedCategory] = useState('todas');

  const categories = [
    { value: 'todas', label: 'Todas' },
    { value: 'reciclada', label: 'Recicladas' },
    { value: 'nueva', label: 'Nuevas' },
    { value: 'cajon', label: 'Cajones' },
    { value: 'huacal', label: 'Huacales' },
    { value: 'personalizada', label: 'Personalizadas' }
  ];

  const filteredProducts = selectedCategory === 'todas' 
    ? productsData 
    : productsData.filter(product => product.category === selectedCategory);

  const handleQuote = (productName) => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      // Store selected product in session storage for contact form
      sessionStorage.setItem('selectedProduct', productName);
    }
  };

  return (
    <section id="productos" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Nuestros <span className="text-green-700">Productos</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Amplio catálogo de tarimas, cajones y huacales de alta calidad
          </p>
        </div>

        {/* Category Tabs */}
        <Tabs defaultValue="todas" className="mb-12" onValueChange={setSelectedCategory}>
          <TabsList className="grid w-full max-w-4xl mx-auto grid-cols-3 lg:grid-cols-6 h-auto gap-2">
            {categories.map((category) => (
              <TabsTrigger 
                key={category.value} 
                value={category.value}
                className="data-[state=active]:bg-green-700 data-[state=active]:text-white py-3"
              >
                {category.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProducts.map((product, index) => (
            <Card 
              key={product.id}
              className="group hover:shadow-2xl transition-all duration-300 overflow-hidden border-2 border-gray-100 hover:border-green-200"
              style={{
                animation: `fadeInUp 0.5s ease-out ${index * 0.1}s both`
              }}
            >
              {/* Product Image */}
              <div className="relative h-64 overflow-hidden bg-gray-100">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <Badge className="absolute top-4 right-4 bg-green-700 text-white">
                  {product.category.charAt(0).toUpperCase() + product.category.slice(1)}
                </Badge>
              </div>

              <CardHeader>
                <CardTitle className="text-xl text-gray-900 group-hover:text-green-700 transition-colors">
                  {product.name}
                </CardTitle>
                <CardDescription className="text-sm text-gray-500 font-medium">
                  Tamaño: {product.size}
                </CardDescription>
              </CardHeader>

              <CardContent>
                <p className="text-gray-600 mb-4">{product.description}</p>
              </CardContent>

              <CardFooter>
                <Button 
                  onClick={() => handleQuote(product.name)}
                  className="w-full bg-green-700 hover:bg-green-800 text-white"
                >
                  <ShoppingCart className="w-4 h-4 mr-2" />
                  Solicitar Cotización
                </Button>
              </CardFooter>
            </Card>
          ))}
        </div>

        {/* No Products Message */}
        {filteredProducts.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">No hay productos en esta categoría</p>
          </div>
        )}
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};
